import React from 'react'
import './Radio.scss'
import { Radio } from 'antd'
const RadioGroup = () => {
  const [value, setValue] = React.useState(1)
  const onChange = (e) => {
    setValue(e.target.value)
  }
  return (
    <Radio.Group className="radio-group" onChange={onChange} value={value}>
      <Radio value={1}>Monthly</Radio>
      <Radio value={2}>Quaterly</Radio>
    </Radio.Group>
  )
}

export default RadioGroup
